var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-body',{scopedSlots:_vm._u([{key:"content",fn:function(){return _vm._l((3),function(index){return _c('div',{staticClass:"py-1"},[_c('folding-card')],1)})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }